/**
 * Generates the QR code payload (as a string) for attending an event.
 *
 * @param event - An object containing the event ID.
 * @returns The QR code payload string for the event access.
 * @throws Error if the event ID is not provided.
 */
export function createEventAccessCodeQRCode(event) {
    if (!event.id) {
        throw new Error('Event ID is required');
    }
    const url = new URL('jebel://event/attend');
    url.searchParams.set('event', event.id);
    return url.toString();
}
